import React, { FC, useEffect, useState } from 'react';

import { AutoDismissFlag, FlagGroup } from '@atlaskit/flag';
import NotificationAllIcon from '@atlaskit/icon/glyph/notification-all';

import { ItemListaNotificacoesMensagemSse } from './model/ItemListaNotificacoes';
import { FiExternalLink } from "react-icons/fi";
import { SRText } from 'view/component/ScreenReaderText/ScreenReaderText';
import { NotificacaoAExibir } from './model/NotificacaoAExibir';

import SuccessIcon from '@atlaskit/icon/glyph/check-circle';
import { G400 } from '@atlaskit/theme/colors';


export interface AlertaNotificacaoPropsGeral {
  /**
   * Client id do sistema no qual está acompanhando
   */
  clientId: string;

  /**
   * Exibir um alerta quando uma nova notificação ocorrer?
   */
  showAlertaNovaNotificacao?: boolean

  /**
   * Tempo em milissegundos entre notificações
   *
   * Se uma notificação chegar em um intervalo menor que o informado, seu alerta
   * será ignorado. Entretanto o título da página e o sininho continuarão 
   * sendo atualizados
   * 
   * A biblioteca que uso fixa em 8 segundos
   */
  // tempoAlertaEntreNovasNotificacoes?: number
}

interface AlertaNotificacaoContainerProps {
  notificacaoAAlertar: NotificacaoAExibir;
  onAlertaClick: (notificacao: ItemListaNotificacoesMensagemSse) => void;
}

interface AlertaNotificacaoProps extends AlertaNotificacaoPropsGeral, AlertaNotificacaoContainerProps {}


export const AlertaNotificacao: FC<AlertaNotificacaoProps> = ({notificacaoAAlertar, clientId, onAlertaClick}) => {
  const [notificacoes, setNotificacoes] = useState<NotificacaoAExibir[]>([]);

  useEffect(() => {
    setNotificacoes(it => [notificacaoAAlertar, ...it]);
  }, [setNotificacoes, notificacaoAAlertar])

  const dismissFlag = () => setNotificacoes(notificacoes.slice(1));

  return (
    <FlagGroup onDismissed={dismissFlag}>
      {notificacoes.map(it => gerarAlertaNotificacaoContainer(it, clientId, onAlertaClick))}
    </FlagGroup>
  );
}

/**
 * Não funcionou gerando um componente funcional (FC)
 */
function gerarAlertaNotificacaoContainer(notificacaoAAlertar: NotificacaoAExibir, clientId: string, onClick: (item: ItemListaNotificacoesMensagemSse) => void) {
  const acoes = gerarAcoes(notificacaoAAlertar, clientId, onClick);
  const notificacao = notificacaoAAlertar.notificacao;

  const icone = notificacaoAAlertar.tipo === 'notificacao'
    ? <NotificationAllIcon label="Nova notificação" aria-hidden />
    : <SuccessIcon label="Success" secondaryColor={G400} />;
  
  return <AutoDismissFlag
    appearance={notificacaoAAlertar.aparencia}
    title={notificacao.titulo}
    icon={icone}
    description={notificacao.mensagem}
    id={notificacao.id}
    key={notificacao.id}
    actions={acoes}
  />
}

function gerarAcoes(notificacaoAExibir: NotificacaoAExibir, clientId: string, onClick: (item: ItemListaNotificacoesMensagemSse) => void) {
  const notificacao = notificacaoAExibir.notificacao;
  
  if (clientId === notificacao.sistema) {
    return [{
      content: 'Visualizar',
      onClick: () => onClick(notificacao as ItemListaNotificacoesMensagemSse),
    }]
  } else if (clientId !== notificacao.sistema && notificacao.metadados['url'] !== undefined) {
    return [{
      content: <>Acessar sistema <SRText>(url externa)</SRText> <FiExternalLink /></>,
      href: notificacao.metadados['url'],
      target: '_blank'
    }]
  } else {
    return []
  }
}


export const AlertaNotificacaoContainer: FC<AlertaNotificacaoProps> = ({notificacaoAAlertar, clientId, onAlertaClick}) => {
  return <>{gerarAlertaNotificacaoContainer(notificacaoAAlertar, clientId, onAlertaClick)}</>
}
